/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

import { useIconIdPrefix } from '~/components/Icons/utils/useIconIdPrefix';

const TvVas = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix('TvVas');

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--tvVas"
      {...props}
    >
      <g clipPath={`url(#${prefix}-clip0_8751_2111)`}>
        <path
          d="M4.00033 0.666656C2.15938 0.666656 0.666992 2.15904 0.666992 3.99999V9.33332C0.666992 9.56163 0.689946 9.78458 0.733671 9.99999H2.00033V3.99999C2.00033 2.89542 2.89576 1.99999 4.00033 1.99999H12.0003C13.1049 1.99999 14.0003 2.89542 14.0003 3.99999V9.99999H15.267C15.3107 9.78458 15.3337 9.56163 15.3337 9.33332V3.99999C15.3337 2.15904 13.8413 0.666656 12.0003 0.666656H4.00033Z"
          fill="white"
        />
        <path
          d="M14.6672 11.3333H1.33341C1.94155 12.143 2.90978 12.6667 4.00033 12.6667H7.33366V14H3.33366V15.3333H12.667V14H8.66699V12.6667H12.0003C13.0909 12.6667 14.0591 12.143 14.6672 11.3333Z"
          fill="white"
        />
        <path d="M12.0003 3.66666L7.33366 8.33332L8.33366 9.33332L13.0003 4.66666L12.0003 3.66666Z" fill="white" />
        <path d="M3.00033 8.33332L7.66699 3.66666L8.66699 4.66666L4.00033 9.33332L3.00033 8.33332Z" fill="white" />
      </g>
      <defs>
        <clipPath id={`${prefix}-clip0_8751_2111`}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

TvVas.displayName = 'tvVas';

export default TvVas;
